import { sendSettings } from "../../lib/socketMessages";
import { logger } from "../../App";
const initState = {
  gameMode: "sonic",
  bet: '',
  currency: "BTC",
  changingMode: false,

  betInfo: {
    selected_numbers: null,
    numbers: null,
    winNumbers: null,
    balance: null,
    winAmount: null,
  },

  // game_settings - game coeficients (coefs)
  game_settings: [],
  // pages data
  provablyFairSeeds: {
    clientSeed: "",
    serverSeedSHA256: "",
    nonce: null,
    old_client_seed: "",
    old_server_seed: "",
    old_server_seed_SHA256: "",
    old_nonce: null,
  },

  audio: {
    sound: true,
    music: true,
    volume: null,
  },

  autoRulesConfigs: {
    numberOfBets: "0",
    onWinReset: true,
    onWinPercent: "0",
    onLossReset: true,
    onLossPercent: "0",
    stopOnProfit: "0",
    stopOnLoss: "0",
  },

  betReplay: {
    server_seed: null,
    server_seed_SHA256: null,
    client_seed: null,
    bet_id: null,
    round_id: null,
    bet_pf_nonce: null,
    autodate: null,
    before_credit: null,
    after_credit: null,
    bet_amount: null,
    win_amount: null,
    win_coef: null,
    user_id: null,
    user_name: null,
    numbers: null,
    selected_numbers: null,
    win_numbers: null,
    currency: null,
    win_amount_type: null,
  },
};

const rootReducer = (state = initState, action) => {
  switch (action.type) {
    case "HANDLE_BET_INFO":
      return {
        ...state,
        balance: action.e.balance,
        betInfo: action.e,
        bet: action.e.betAmount,
      };

    case "HANDLE_BET":
      return {
        ...state,
        bet: action.bet,
      };

    case "HANDLE_AUTO_RULES_CONFIGS":
      logger.log(
        "%HANDLE_AUTO_RULES_CONFIGS ",
        "color:green; font-size: x-large",
        action.e
      );
      // sendSettings({ bet: state.bet, auto: action.e, audio: state.audio });
      return { ...state, autoRulesConfigs: action.e };

    case "HANDLE_AUDIO":
      logger.log(
        "%cHANDLE_AUDIO ",
        "color:green; font-size: x-large",
        action.e
      );
      sendSettings({
        bet: state.bet,
        auto: state.autoRulesConfigs,
        audio: action.e,
      }, state.min, state.max);
      return { ...state, audio: action.e };

    case "HANDLE_SETTINGS":
      logger.log(
        "%cHANDLE_SETTINGS",
        "color:coral; font-size: medium",
        action.e
      );
      const { bet, auto, audio } = action.e;
      return {
        ...state,
        bet,
        autoRulesConfigs: auto,
        audio,
      };

    case "SAVE_SETTINGS":
      sendSettings({
        bet: state.bet,
        auto: state.autoRulesConfigs,
        audio: state.audio,
      }, state.min, state.max);
      return state;
    case "TURN_MODE":
      return {
        ...state,
        gameMode: action.m,
      };

    case "TOOGLE_CHANGINGMODE":
      return {
        ...state,
        changingMode: action.e,
      };

    case "HANDLE_BET_REPLAY":
      return {
        ...state,
        betReplay: action.e,
      };

    case "GET_SEEDS_RESPONCE":
      return {
        ...state,
        provablyFairSeeds: action.e,
      };

    case "GAME_STATE":
      let {
        balance,
        clientSeed,
        serverSeedSHA256,
        nonce,
        minBet,
        maxBet,
        game_settings,
      } = action.e;

      // logger.log(action.e.game_settings);

      if (minBet && maxBet) {
        return {
          ...state,
          balance,
          game_settings,
          min: minBet.toFixed(8),
          bet: minBet.toFixed(8),
          max: maxBet.toFixed(8),
          provablyFairSeeds: {
            clientSeed,
            serverSeedSHA256,
            nonce,
          },
        };
      } else {
        return {
          ...state,
          balance,
          provablyFairSeeds: {
            clientSeed,
            serverSeedSHA256,
            nonce,
          },
        };
      }

    default:
      return state;
  }
};

export default rootReducer;
